import { Injectable, InjectionToken, Inject } from '@angular/core';
import { CONSOLE } from './tokens';
export class ErrorReporter {
/**
 * @param {?} console
 */
constructor(
private console: any) {}
/**
 * @param {?} reason
 * @param {?} details
 * @return {?}
 */
report(reason: string, details: any): void {
    this.console.group(reason);

    for (let /** @type {?} */ key in details) {
      this.console.error(`${key}:`, details[key]);
    }

    this.console.groupEnd();
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [CONSOLE, ] }, ]},
];
}

function ErrorReporter_tsickle_Closure_declarations() {
/** @type {?} */
ErrorReporter.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ErrorReporter.ctorParameters;
/** @type {?} */
ErrorReporter.prototype.console;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/effects/src/error_reporter.ts